/*!

 =========================================================
 * Vue Now UI Kit - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/now-ui-kit
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from 'vue';
import App from './App.vue';
// You can change this import to `import router from './starterRouter'` to quickly start development from a blank layout.
import router from './router';
import NowUiKit from './plugins/now-ui-kit';
import Notify from 'vue2-notify'
import i18n from './i18n';

Vue.config.productionTip = false;

Vue.use(NowUiKit);
Vue.use(Notify, {enter: 'fadeIn', leave: 'slideUp', position: 'bottom-right'})

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');
